// Get router
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="flex w-full px-6 fixed bottom-1 left-0 right-0 items-center justify-between h-10 sm:h-16 bg-black/50 backdrop-blur-sm shadow-md">
      {/* <div className="flex justify-center items-center gap-4">
          <img
            src="/img/discord-logo.png"
            className="h-5 w-5 sm:h-10 sm:w-10"
            alt="Logo"
          />
          <img
            src="/img/twitter-logo.png"
            className="h-5 w-5 sm:h-10 sm:w-10"
            alt="Logo"
          />
          <img
            src="/img/instagram-logo.png"
            className="h-5 w-5 sm:h-10 sm:w-10"
            alt="Logo"
          />
          <img
            src="/img/facebook-logo.png"
            className="h-5 w-5 sm:h-10 sm:w-10"
            alt="Logo"
          />
          <img
            src="/img/linkedin-logo.png"
            className="h-5 w-5 sm:h-10 sm:w-10"
            alt="Logo"
          />
        </div> */}

      <div className="flex flex-col">
        <div className="text-gray-200 text-[1.7vw] sm:text-[1vw]">
          © 2025 Emotionly
        </div>
        <div className="text-gray-200 text-[1vw] sm:text-[0.8vw]">
          All rights reserved.
        </div>
      </div>

      <div className="flex cursor-pointer gap-4 sm:gap-8 items-center justify-center">
        <Link
          to="/privacy"
          className="text-gray-200 text-[1.5vw] sm:text-[1vw] hover:text-gray-400 "
        >
          Privacy Policy
        </Link>
        <Link
          to="/terms"
          className="text-gray-200 text-[1.5vw] sm:text-[1vw] hover:text-gray-400"
        >
          Terms of Service
        </Link>
        {/* <div
          onClick={() => {}}
          className="text-gray-200 text-[1.5vw] sm:text-[1vw] hover:text-gray-400"
        >
          Contact Us
        </div> */}
      </div>
    </div>
  );
}

export default Footer;
